import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchEmployeeAdvertisement from '.';

interface IPostEmployeeAdvertisementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchEmployeeAdvertisement = ({
  onSuccess,
  guid,
}: IPostEmployeeAdvertisementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IEmployeeAdvertisementPayload) => {
      return PatchEmployeeAdvertisement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchEmployeeAdvertisement};
